import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { CoreButton } from 'src/components/core'
import { track } from '@amplitude/analytics-browser'

const bullets = [
  {
    label: 'Shared Workspace',
    text: 'One place for your entire team to create and manage courses.',
  },
  {
    label: 'Role-Based Permissions',
    text: 'Admin, Editor, and Viewer roles to match how your team works.',
  },
  {
    label: 'Full Credits Per Member',
    text: 'Every teammate gets their own full credit allowance based on your workspace plan.',
  },
]

const WorkspaceUpgradeContent = () => {
  const handleCta = () => {
    track('workspace_upgrade_popup_cta_clicked')
    window.location.href = '/pricing'
  }

  return (
    <Box style={{ width: '100%' }}>

      {/* Title + subtitle */}
      <Box style={{ display: 'flex', flexDirection: 'column', gap: 16, textAlign: 'center', marginBottom: 24 }}>
        <Typography style={{ fontFamily: 'Inter', fontWeight: 600, fontSize: 24, color: '#002E47', lineHeight: 1.5 }}>
          Build Great Courses, Together
        </Typography>
        <Typography style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: 14, color: '#637381', lineHeight: 1.5 }}>
          Bring your team on board to work on courses together and manage your entire workspace in one place.
        </Typography>
      </Box>

      {/* Illustration */}
      <Box style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
        <Box style={{ borderRadius: 12, overflow: 'hidden', width: '100%', maxWidth: 640 }}>
          <img
            alt=""
            src="/assets/workspace-upgrade-illustration.png"
            style={{ display: 'block', width: '100%' }}
          />
        </Box>
      </Box>

      {/* Benefit bullets */}
      <Box style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {bullets.map(({ label, text }) => (
          <Box key={label} style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
            <Box style={{ display: 'flex', alignItems: 'center', padding: '2px 0', flexShrink: 0 }}>
              <Icon icon="icon-park-solid:check-one" style={{ fontSize: 20, color: '#015FFB' }} />
            </Box>
            <Typography style={{ fontFamily: 'Inter', fontWeight: 500, fontSize: 14, color: '#002e47', lineHeight: 1.5, flex: 1 }}>
              <strong style={{ fontWeight: 600 }}>{label}:</strong>{' '}
              <span style={{ fontWeight: 400 }}>{text}</span>
            </Typography>
          </Box>
        ))}
      </Box>

      {/* CTA */}
      <Box style={{ padding: '16px 0 0' }}>
        <CoreButton
          variant="contained"
          fullWidth
          onClick={handleCta}
          style={{
            backgroundColor: '#015FFB',
            borderRadius: 8,
            letterSpacing: '0.43px',
            fontSize: 14,
            fontFamily: 'Inter',
            fontWeight: 500,
            padding: '10px 20px',
            textTransform: 'none',
            color: 'white',
            lineHeight: '18px',
          }}
        >
          Upgrade to Unlock Team Access
        </CoreButton>
      </Box>

    </Box>
  )
}

export default WorkspaceUpgradeContent
